import { OrderStatusEnum } from "enums/OrderStatus.enum";

export const OrderStatus = {
  [OrderStatusEnum.GENERATED]: {
    className: "bg-white text-black",
    label: "Generated"
  },
  [OrderStatusEnum.PAID]: {
    className: "bg-green-700 text-green-100",
    label: "Paid"
  },
  [OrderStatusEnum.CANCELLED]: {
    className: "bg-red-600 text-red-100",
    label: "Cancelled"
  },
  [OrderStatusEnum.REFUND]: {
    className: "bg-yellow-500 text-yellow-100",
    label: "Refund"
  }
};
